<template>
  <div v-if="listItems && listItems.length > 0" v-show="imgReady" @wheel="wheelScroll">
    <div class="focus-area">
      <img class="banner-img dummy" :style="bannerStyleObject" :src="bannerImgSrc" v-if="routeName == 'home'"
        @load="onImgLoad" />
      <div v-if="mouseActivated" class="remote-focus" :style="remoteFocusStyleObject">
        <div v-show="focusedLine > 0" class="arrow-box up" @click="upKeyProc" @mouseover="mouseFocus = 'U'"
          @mouseleave="mouseFocus = ''" :style="arrowBoxStyleObject">
          <img v-if="mouseFocus == 'U'" class="arrow" src="@/assets/button-remote-control-focuson-up.png" />
          <img v-else class="arrow" src="@/assets/button-remote-control-up.png" />
        </div>
        <div v-if="focusedLine < maxLine" class="arrow-box down" @click="downKeyProc" @mouseover="mouseFocus = 'D'"
          @mouseleave="mouseFocus = ''" :style="arrowBoxStyleObject">
          <img v-if="mouseFocus == 'D'" class="arrow" src="@/assets/button-remote-control-focuson-down.png" />
          <img v-else class="arrow" src="@/assets/button-remote-control-down.png" />
        </div>
      </div>
      <div class="default-focus" :style="componentStyle" v-else-if="focusedView == 'default'"></div>
    </div>
    <div class="list" :style="computedStyleObject" ref="listMain">
      <img class="banner-img" :style="bannerStyleObject" :src="bannerImgSrc" v-if="routeName == 'home'" ref="banner" />
      <div v-for="list in listItems" :key="list.seqNo" ref="list" class="horizontal-area">
        <horizontal-slider :listData="list" :focusedLine.sync="focusedLine" :componentStyle="componentStyle"
          :isActiveVue="isActiveVue"></horizontal-slider>
      </div>
    </div>
  </div>
</template>

<script>
import { isGolf } from "@/utils/common";
import HorizontalSlider from "./HorizontalSlider.vue";

export default {
  props: ["topBanner", "listItems", "componentStyle", "isActiveVue"],
  components: {
    HorizontalSlider,
  },
  data() {
    return {
      top: 0,
      focusedLine: 0,
      bannerLoaded: false,
      mouseFocus: "",
      animationRunning: false,
      aniObj: null,
      isGolfService: isGolf,
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    focusedView() {
      return this.$store.getters.focusedView;
    },
    computedStyleObject() {
      return {
        top: this.top + "px",
        // "left" : this.componentStyle.left,
      };
    },
    remoteFocusStyleObject() {
      return {
        height: this.componentStyle.height,
      };
    },
    arrowBoxStyleObject() {
      return {
        left: this.componentStyle.left,
        width: Number(window.innerWidth) == 1920 ? 1920 - this.componentStyle.left.replace("px", "") + "px" : 1280 - this.componentStyle.left.replace("px", "") + "px"
      };
    },
    bannerStyleObject() {
      return {
        left: this.componentStyle.left,
        // width: 1920 - this.componentStyle.left.replace("px", "") + "px",
        width: Number(window.innerWidth) - this.componentStyle.left.replace("px", "") + "px",
      };
    },
    maxLine() {
      return (this.listItems.count || this.listItems.length) - 1;
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
    routeName() {
      return this.$route.name;
    },
    bannerImgSrc() {
      if (Array.isArray(this.topBanner) && this.topBanner.length > 0) {
        return this.topBanner[0].imgUrl;
      } else {
        return this.isGolfService ? require("@/assets/golf/golf-default-banner.png") : require("@/assets/home-main-banner.png");
      }
    },
    imgReady() {
      if (this.routeName === "home") {
        return this.bannerLoaded;
      } else {
        return true;
      }
    },
    listMain() {
      return this.$refs.listMain;
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (
        this.isActiveVue &&
        val.focusView == "default" &&
        this.imgReady &&
        !this.animationRunning
      ) {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
    focusedLine(val, oldVal) {
      this.animationRunning = true;
      this.top = this.getScrollPixsel(val) * val * -1;
      if (this.aniObj == null) {
        this.setAniEventListener();
      }
    }
  },

  methods: {
    upKeyProc(keyInput) {
      if (this.focusedLine > 0) {
        --this.focusedLine;
      } else if (this.focusedLine == 0) {
        if (this.$route.path.indexOf('home') > 0) this.$emit('refresh')
      }
    },
    downKeyProc(keyInput) {
      if (this.focusedLine < this.maxLine) {
        ++this.focusedLine;
      } else if (this.focusedLine == this.maxLine) {
        if (this.$route.path.indexOf('home') > 0) this.$emit('refresh')
      }
    },
    leftKeyProc(keyInput) {
      if (this.maxLine < 0) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      }
    },
    backKeyProc(keyInput) {
      this.$store.commit("SET_FOCUSED_VIEW", "gnb");
    },
    getScrollPixsel() {
      if (!this.$refs.list || this.$refs.list.length === 0) {
        return 0;
      }

      return this.$refs.list[0].clientHeight;
    },
    onImgLoad() {
      this.bannerLoaded = true;
    },
    setAniEventListener() {
      if (this.$refs.listMain) {
        this.aniObj = this.$refs.listMain;
        this.aniObj.addEventListener("transitionend", this.transitionEndHandler)
      }
    },
    removeAniEventListener() {
      if (this.aniObj) {
        this.aniObj.removeEventListener("transitionend", this.transitionEndHandler)
        this.aniObj = null
      }
    },
    transitionEndHandler() {
      if (this.focusedLine === this.maxLine) {
        this.$emit('loadMore')
      }

      this.animationRunning = false      
    },
    wheelScroll(e) {
      if (this.isActiveVue && !this.animationRunning) {
        if (e.deltaY > 0) {
          this.downKeyProc();
        } else {
          this.upKeyProc();
        }
      }
    },
  },
  activated() {
    this.$store.commit("SET_FOCUSED_VIEW", "default");
  },
  deactivated() {
    this.animationRunning = false;
  },
  beforeDestroy() {
    this.removeAniEventListener();
  }
};
</script>

<style scoped>
.list {
  position: relative;
  width: 100%;
  height: 100%;
  transition-duration: 0.2s;
  margin-top: 20px;
}

.focus-area {
  position: absolute;
  top: 87px;
}

.default-focus {
  margin-top: 4px;
  border: solid 4px #eeeeee;
  z-index: 5;
}

.banner-img {
  z-index: 2;
}

.banner-img.dummy {
  visibility: hidden;
}

.arrow-box {
  position: absolute;
  height: 64px;
  z-index: 4;
  text-align: center;
}

.arrow-box.up {
  top: -64px;
}

.arrow-box.down {
  bottom: -80px;
}

.arrow {
  width: 64px;
  height: 64px;
}

@media all and (min-width:0px) and (max-width:1280px) {
  .list {
    margin-top: 0px;
  }

  .default-focus {
    margin-top: -10px;
    border: solid 3px #ffffff;
  }
}
</style>